import chartistjs from 'chartist/dist/chartist.min.js';
import moment from 'moment';

moment.locale('pl');

moment.updateLocale('pl', {
  weekdaysShort: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So']
});

/**
 * Mixin metod wykresów
 * Zawiera metody:
 *  - `toDayOfWeek(day)` - Zwraca nazwę dnia tygodnia na podstawie jego numeru
 *  - `generateChartData(stat)` - Generuje dane do wykresu
 */
export const chartMixin = {
  methods: {
    /**
     * Generuje dane do wykresu
     *
     * @param {*} stat
     */
    generateChartData(stat) {
      const today = moment().endOf('day');
      const labels = [today.format('ddd')];
      for (let i = 0; i < 6; i++) {
        labels.unshift(today.subtract(1, 'days').format('ddd'));
      }

      let series = chartistjs.times(labels.length);
      Object.keys(stat).forEach(date => {
        const index = labels.findIndex(label => label === moment(date).format('ddd'));
        series.splice(index, 1, stat[date]);
      });

      series = [series];
      return { labels, series };
    }
  }
};
